"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CronExpression = exports.DurationUnit = exports.SystemModuleType = exports.ListenerType = exports.ModuleType = exports.TokenMintType = exports.EventSignatureHash = exports.EventSignature = exports.TokenRarity = void 0;
var TokenRarity;
(function (TokenRarity) {
    TokenRarity["COMMON"] = "COMMON";
    TokenRarity["UNCOMMON"] = "UNCOMMON";
    TokenRarity["RARE"] = "RARE";
    TokenRarity["EPIC"] = "EPIC";
    TokenRarity["LEGENDARY"] = "LEGENDARY";
})(TokenRarity || (exports.TokenRarity = TokenRarity = {}));
var EventSignature;
(function (EventSignature) {
    EventSignature["MintRandom"] = "MintRandom(uint256,address,uint256[],uint256,uint256)";
    EventSignature["Transfer"] = "Transfer(address,address,uint256)";
})(EventSignature || (exports.EventSignature = EventSignature = {}));
var EventSignatureHash;
(function (EventSignatureHash) {
    EventSignatureHash["MintRandom"] = "0xa29d42f2e56701221b7574eaf57e07a4bdd20605c2bdbe1d244c9e9ddd255e00";
    EventSignatureHash["Transfer"] = "0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef";
})(EventSignatureHash || (exports.EventSignatureHash = EventSignatureHash = {}));
var TokenMintType;
(function (TokenMintType) {
    TokenMintType["MintRandom"] = "MintRandom";
    TokenMintType["MintCommon"] = "MintCommon";
})(TokenMintType || (exports.TokenMintType = TokenMintType = {}));
var ModuleType;
(function (ModuleType) {
    ModuleType["CONTRACT_MANAGER"] = "CONTRACT_MANAGER";
    ModuleType["EXCHANGE"] = "EXCHANGE";
    ModuleType["DISPENSER"] = "DISPENSER";
    ModuleType["CHAIN_LINK"] = "CHAIN_LINK";
    ModuleType["HIERARCHY"] = "HIERARCHY";
    ModuleType["COLLECTION"] = "COLLECTION";
    ModuleType["LOOT"] = "LOOT";
    ModuleType["MYSTERY"] = "MYSTERY";
    ModuleType["WRAPPER"] = "WRAPPER";
    ModuleType["LOTTERY"] = "LOTTERY";
    ModuleType["RAFFLE"] = "RAFFLE";
    ModuleType["PONZI"] = "PONZI";
    ModuleType["VESTING"] = "VESTING";
    ModuleType["STAKING"] = "STAKING";
    ModuleType["WAIT_LIST"] = "WAIT_LIST";
    ModuleType["PAYMENT_SPLITTER"] = "PAYMENT_SPLITTER";
    ModuleType["PREDICTION"] = "PREDICTION";
})(ModuleType || (exports.ModuleType = ModuleType = {}));
var ListenerType;
(function (ListenerType) {
    ListenerType["ERC20"] = "ERC20";
    ListenerType["ERC721"] = "ERC721";
    ListenerType["ERC721_RANDOM"] = "ERC721_RANDOM";
    ListenerType["ERC998"] = "ERC998";
    ListenerType["ERC998_RANDOM"] = "ERC998_RANDOM";
    ListenerType["ERC1155"] = "ERC1155";
    ListenerType["LOOT"] = "LOOT";
    ListenerType["MYSTERY"] = "MYSTERY";
    ListenerType["VESTING"] = "VESTING";
    ListenerType["STAKING"] = "STAKING";
    ListenerType["PONZI"] = "PONZI";
    ListenerType["PAYMENT_SPLITTER"] = "PAYMENT_SPLITTER";
    ListenerType["PREDICTION"] = "PREDICTION";
    ListenerType["LOTTERY"] = "LOTTERY";
    ListenerType["LOTTERY_TICKET"] = "LOTTERY_TICKET";
    ListenerType["RAFFLE"] = "RAFFLE";
    ListenerType["RAFFLE_TICKET"] = "RAFFLE_TICKET";
    ListenerType["WAIT_LIST"] = "WAIT_LIST";
    ListenerType["CONTRACT_MANAGER"] = "CONTRACT_MANAGER";
    ListenerType["CHAIN_LINK"] = "CHAIN_LINK";
    ListenerType["COLLECTION"] = "COLLECTION";
})(ListenerType || (exports.ListenerType = ListenerType = {}));
var SystemModuleType;
(function (SystemModuleType) {
    SystemModuleType["CONTRACT_MANAGER"] = "CONTRACT_MANAGER";
    SystemModuleType["EXCHANGE"] = "EXCHANGE";
    SystemModuleType["DISPENSER"] = "DISPENSER";
    SystemModuleType["CHAIN_LINK"] = "CHAIN_LINK";
})(SystemModuleType || (exports.SystemModuleType = SystemModuleType = {}));
var DurationUnit;
(function (DurationUnit) {
    DurationUnit["YEAR"] = "YEAR";
    DurationUnit["MONTH"] = "MONTH";
    DurationUnit["WEEK"] = "WEEK";
    DurationUnit["DAY"] = "DAY";
    DurationUnit["HOUR"] = "HOUR";
    DurationUnit["MINUTE"] = "MINUTE";
})(DurationUnit || (exports.DurationUnit = DurationUnit = {}));
var CronExpression;
(function (CronExpression) {
    CronExpression["EVERY_SECOND"] = "* * * * * *";
    CronExpression["EVERY_5_SECONDS"] = "*/5 * * * * *";
    CronExpression["EVERY_10_SECONDS"] = "*/10 * * * * *";
    CronExpression["EVERY_30_SECONDS"] = "*/30 * * * * *";
    CronExpression["EVERY_MINUTE"] = "*/1 * * * *";
    CronExpression["EVERY_5_MINUTES"] = "0 */5 * * * *";
    CronExpression["EVERY_10_MINUTES"] = "0 */10 * * * *";
    CronExpression["EVERY_30_MINUTES"] = "0 */30 * * * *";
    CronExpression["EVERY_HOUR"] = "0 0-23/1 * * *";
    CronExpression["EVERY_2_HOURS"] = "0 0-23/2 * * *";
    CronExpression["EVERY_3_HOURS"] = "0 0-23/3 * * *";
    CronExpression["EVERY_4_HOURS"] = "0 0-23/4 * * *";
    CronExpression["EVERY_5_HOURS"] = "0 0-23/5 * * *";
    CronExpression["EVERY_6_HOURS"] = "0 0-23/6 * * *";
    CronExpression["EVERY_7_HOURS"] = "0 0-23/7 * * *";
    CronExpression["EVERY_8_HOURS"] = "0 0-23/8 * * *";
    CronExpression["EVERY_9_HOURS"] = "0 0-23/9 * * *";
    CronExpression["EVERY_10_HOURS"] = "0 0-23/10 * * *";
    CronExpression["EVERY_11_HOURS"] = "0 0-23/11 * * *";
    CronExpression["EVERY_12_HOURS"] = "0 0-23/12 * * *";
    CronExpression["EVERY_DAY_AT_1AM"] = "0 01 * * *";
    CronExpression["EVERY_DAY_AT_2AM"] = "0 02 * * *";
    CronExpression["EVERY_DAY_AT_3AM"] = "0 03 * * *";
    CronExpression["EVERY_DAY_AT_4AM"] = "0 04 * * *";
    CronExpression["EVERY_DAY_AT_5AM"] = "0 05 * * *";
    CronExpression["EVERY_DAY_AT_6AM"] = "0 06 * * *";
    CronExpression["EVERY_DAY_AT_7AM"] = "0 07 * * *";
    CronExpression["EVERY_DAY_AT_8AM"] = "0 08 * * *";
    CronExpression["EVERY_DAY_AT_9AM"] = "0 09 * * *";
    CronExpression["EVERY_DAY_AT_10AM"] = "0 10 * * *";
    CronExpression["EVERY_DAY_AT_11AM"] = "0 11 * * *";
    CronExpression["EVERY_DAY_AT_NOON"] = "0 12 * * *";
    CronExpression["EVERY_DAY_AT_1PM"] = "0 13 * * *";
    CronExpression["EVERY_DAY_AT_2PM"] = "0 14 * * *";
    CronExpression["EVERY_DAY_AT_3PM"] = "0 15 * * *";
    CronExpression["EVERY_DAY_AT_4PM"] = "0 16 * * *";
    CronExpression["EVERY_DAY_AT_5PM"] = "0 17 * * *";
    CronExpression["EVERY_DAY_AT_6PM"] = "0 18 * * *";
    CronExpression["EVERY_DAY_AT_7PM"] = "0 19 * * *";
    CronExpression["EVERY_DAY_AT_8PM"] = "0 20 * * *";
    CronExpression["EVERY_DAY_AT_9PM"] = "0 21 * * *";
    CronExpression["EVERY_DAY_AT_10PM"] = "0 22 * * *";
    CronExpression["EVERY_DAY_AT_11PM"] = "0 23 * * *";
    CronExpression["EVERY_DAY_AT_MIDNIGHT"] = "0 0 * * *";
    CronExpression["EVERY_WEEK"] = "0 0 * * 0";
    CronExpression["EVERY_WEEKDAY"] = "0 0 * * 1-5";
    CronExpression["EVERY_WEEKEND"] = "0 0 * * 6,0";
    CronExpression["EVERY_1ST_DAY_OF_MONTH_AT_MIDNIGHT"] = "0 0 1 * *";
    CronExpression["EVERY_1ST_DAY_OF_MONTH_AT_NOON"] = "0 12 1 * *";
    CronExpression["EVERY_2ND_HOUR"] = "0 */2 * * *";
    CronExpression["EVERY_2ND_HOUR_FROM_1AM_THROUGH_11PM"] = "0 1-23/2 * * *";
    CronExpression["EVERY_2ND_MONTH"] = "0 0 1 */2 *";
    CronExpression["EVERY_QUARTER"] = "0 0 1 */3 *";
    CronExpression["EVERY_6_MONTHS"] = "0 0 1 */6 *";
    CronExpression["EVERY_YEAR"] = "0 0 1 1 *";
    CronExpression["EVERY_30_MINUTES_BETWEEN_9AM_AND_5PM"] = "0 */30 9-17 * * *";
    CronExpression["EVERY_30_MINUTES_BETWEEN_9AM_AND_6PM"] = "0 */30 9-18 * * *";
    CronExpression["EVERY_30_MINUTES_BETWEEN_10AM_AND_7PM"] = "0 */30 10-19 * * *";
    CronExpression["MONDAY_TO_FRIDAY_AT_1AM"] = "0 0 01 * * 1-5";
    CronExpression["MONDAY_TO_FRIDAY_AT_2AM"] = "0 0 02 * * 1-5";
    CronExpression["MONDAY_TO_FRIDAY_AT_3AM"] = "0 0 03 * * 1-5";
    CronExpression["MONDAY_TO_FRIDAY_AT_4AM"] = "0 0 04 * * 1-5";
    CronExpression["MONDAY_TO_FRIDAY_AT_5AM"] = "0 0 05 * * 1-5";
    CronExpression["MONDAY_TO_FRIDAY_AT_6AM"] = "0 0 06 * * 1-5";
    CronExpression["MONDAY_TO_FRIDAY_AT_7AM"] = "0 0 07 * * 1-5";
    CronExpression["MONDAY_TO_FRIDAY_AT_8AM"] = "0 0 08 * * 1-5";
    CronExpression["MONDAY_TO_FRIDAY_AT_9AM"] = "0 0 09 * * 1-5";
    CronExpression["MONDAY_TO_FRIDAY_AT_09_30AM"] = "0 30 09 * * 1-5";
    CronExpression["MONDAY_TO_FRIDAY_AT_10AM"] = "0 0 10 * * 1-5";
    CronExpression["MONDAY_TO_FRIDAY_AT_11AM"] = "0 0 11 * * 1-5";
    CronExpression["MONDAY_TO_FRIDAY_AT_11_30AM"] = "0 30 11 * * 1-5";
    CronExpression["MONDAY_TO_FRIDAY_AT_12PM"] = "0 0 12 * * 1-5";
    CronExpression["MONDAY_TO_FRIDAY_AT_1PM"] = "0 0 13 * * 1-5";
    CronExpression["MONDAY_TO_FRIDAY_AT_2PM"] = "0 0 14 * * 1-5";
    CronExpression["MONDAY_TO_FRIDAY_AT_3PM"] = "0 0 15 * * 1-5";
    CronExpression["MONDAY_TO_FRIDAY_AT_4PM"] = "0 0 16 * * 1-5";
    CronExpression["MONDAY_TO_FRIDAY_AT_5PM"] = "0 0 17 * * 1-5";
    CronExpression["MONDAY_TO_FRIDAY_AT_6PM"] = "0 0 18 * * 1-5";
    CronExpression["MONDAY_TO_FRIDAY_AT_7PM"] = "0 0 19 * * 1-5";
    CronExpression["MONDAY_TO_FRIDAY_AT_8PM"] = "0 0 20 * * 1-5";
    CronExpression["MONDAY_TO_FRIDAY_AT_9PM"] = "0 0 21 * * 1-5";
    CronExpression["MONDAY_TO_FRIDAY_AT_10PM"] = "0 0 22 * * 1-5";
    CronExpression["MONDAY_TO_FRIDAY_AT_11PM"] = "0 0 23 * * 1-5";
})(CronExpression || (exports.CronExpression = CronExpression = {}));
//# sourceMappingURL=common.js.map